import { all, call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import {
  fetchKarmaEarnGameListApi,
  fetchKarmaEarnOfferListApi,
  fetchKarmaEarnSurveyListApi,
} from 'store/karmaEarnList/api';
import { addItems, receiveItems, resetItems, setIsLoading, setIsVpnDetected } from 'store/karmaEarnList/actions';
import { OFFER_TYPES } from 'consts/karmaEarn';
import { SESSION_STORAGE_ITEMS } from 'consts/sessionStorage';

function* fetchKarmaEarnListWorker({ payload: { page, genres, types, isMyOffers, offerType } }) {
  try {
    if (page === 1) {
      yield all([put(resetItems()), put(setIsLoading(true))]);
    } else {
      yield put(setIsLoading(true));
    }

    const isSurveys = offerType === OFFER_TYPES.ANSWER_SURVEYS;

    const fetchFunc = (() => {
      if (offerType === OFFER_TYPES.OFFERS) return fetchKarmaEarnOfferListApi;
      if (isSurveys) return fetchKarmaEarnSurveyListApi;

      return fetchKarmaEarnGameListApi;
    })();

    const seedKey = (() => {
      if (offerType === OFFER_TYPES.OFFERS) return SESSION_STORAGE_ITEMS.seedForKarmaEarnOfferList;

      return SESSION_STORAGE_ITEMS.seedForKarmaEarnGameList;
    })();

    const { data } = yield call(
      fetchFunc,
      isSurveys
        ? {
            page,
            size: 24,
            my_offers: isMyOffers,
          }
        : {
            page,
            size: 24,
            sort: 'amount%20desc',
            genre: typeof genres === 'string' ? genres : genres.join(','),
            device_type: typeof types === 'string' ? types : types.join(','),
            my_offers: isMyOffers,
            seed: sessionStorage.getItem(seedKey) || 0,
          },
    );

    const payload = {
      page,
      isLastPage: data?.['last-page'] ?? true,
      karmaEarnItems: data?.list || [],
    };

    if (!isSurveys && data?.seed) {
      sessionStorage.setItem(seedKey, data?.seed);
    }

    yield put(page === 1 ? receiveItems(payload) : addItems(payload));
  } catch (error) {
    yield put(handleServerError(error));

    if (error?.data?.code === 'vpn_detected') {
      yield put(setIsVpnDetected(true));
    } else {
      yield put(receiveItems({ page, isLastPage: true, karmaEarnItems: [] }));
    }
  }
}

export default fetchKarmaEarnListWorker;
